import { useMemo } from 'react';
import { useAppStore } from '@modules/app/store/useAppStore';
import { Areas } from '@thive/fddm-types';

import { useFloorplanDesignStore } from '../store/useFloorplanDesignStore';
import { filterAreasByIds } from '../helpers';

/**
 * @caution USE THIS HOOK WITH CAUTION, ENSURE THIS DOES NOT CAUSE UNNECESSARY RE-RENDERS.
 */
export const useReadSelectedAreas = (): Areas => {
  const ids = useAppStore((state) => state.selectedIds);
  const allAreas = useFloorplanDesignStore((state) => state.design.areas);
  return useMemo(() => filterAreasByIds(allAreas, ids), [allAreas, ids]);
};
